'use client'

/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */

import Link from 'next/link'
import { useRouter, usePathname } from 'next/navigation'
import Image from 'next/image'
import assetLoader from '@utils/assetloader'
import { cn } from '@utils/utils'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFuncAckoDrive } from '@utils/segmentProperties'
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'
import { getSegmentKey } from '@utils/AckoDriveNewKey'
import styles from './BottomNavItem.module.scss'
// import { useGlobalLoader } from 'hooks/useGlobalLoader'
// import eventTrackerService, { EventType } from '@/Services/eventTracker'

// import { getUserTrackerId } from "utils/newEvents";

interface BottomNavItemProps {
  href: string
  inactiveIcon: string
  activeIcon: string
  label: string
  exactMatch?: boolean
  actionName: string
  cityName?: any
}

const BottomNavItem = ({
  href,
  inactiveIcon,
  activeIcon,
  label,
  exactMatch = true,
  actionName,
  cityName,
}: BottomNavItemProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const config = useEnvVariablesClientConfig()

  const isExternalUrl = href.startsWith('http')

  const isActive = label === 'News'
  const currentIcon = isActive ? activeIcon : inactiveIcon

  const handleClick = async () => {
    //  showLoader(`Loading...`)
    const currentEnv = config?.ACKO_ENV
    const SEGMENT_WRITE_KEY = getSegmentKey(currentEnv)
    const eventProperties = segmentEventCommonPropFuncAckoDrive({ pageType: '' })
    await trackEvent(
      'action',
      {
        ...eventProperties,
        pageType: 'Bottom Navigation',
        additionalProps: {
          action_type: 'tap_btn',
          action_name: actionName,
          section: 'Bottom Navigation',
        },
      },
      SEGMENT_WRITE_KEY
    )

    if (isExternalUrl) {
      window.open(href, '_blank')
      return
    }

    if (pathname !== href) {
      router.push(href)
    }
  }

  if (isExternalUrl || pathname === href) {
    return (
      <Link href={href} className={cn(styles.navItem, isActive && styles.active)}>
        <div className={styles.iconWrapper}>
          <Image
            src={`${assetLoader()}${currentIcon}`}
            alt={label}
            width={24}
            height={24}
            className={styles.icon}
            priority
          />
        </div>
        <span className={styles.label}>{label}</span>
      </Link>
    )
  }

  return (
    <div
      className={`${styles.navItem} ${isActive ? styles.active : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick()
        }
      }}>
      <div className={styles.iconWrapper}>
        <Image
          src={`${assetLoader()}${currentIcon}`}
          alt={label}
          width={24}
          height={24}
          className={styles.icon}
          priority
        />
      </div>
      <span className={styles.label}>{label}</span>
    </div>
  )
}

export default BottomNavItem
